import { Dict } from './decorable';
export type SimpleHandler = () => void;
export type TypedHandler<T> = (params: T) => void;
export type SimpleTypedHandler<V> = () => V;
export type Handler<T, V> = (args: T) => V;
export type AnyHandler = (args?: any) => void;
export type DictHandler = (args: Dict) => void;
export type EmptyObject = {};
export function DoNothing(): void {};
